module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai87-88335ff77fa576d483f08ca015be0943.jpg";